import { takeLatest, select, put } from 'redux-saga/effects'
import { Types } from '../ducks/files'
import { notifyError, notifySuccess } from '../../utils/notify'
import powerAppsApi from '../../services/powerapps/index'

function* addFile(action) {
  try {
    const { tabRef, tabId, desc, file } = action.payload
    const userEmail = yield select(state => state.auth.user.mail)

    const formData = new FormData()
    formData.append('user_email', userEmail)
    formData.append('acao', 'incluir_arquivo')
    formData.append('arquivo_tabRef', tabRef)
    formData.append('arquivo_tabId', tabId)
    formData.append('arquivo_desc', desc)
    formData.append('arquivos', new Blob([file], { type: file.type }), file.name || desc)

    console.tron.log('addFile formData', formData)

    const res = yield powerAppsApi.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.tron.log('incluir_arquivo', res.data)

    yield put({
      type: Types.ADD_FILE_SUCCEEDED,
      payload: res.data,
    })

    notifySuccess('Arquivo adicionado com sucesso.')
  } catch (err) {
    console.tron.log('Erro ao adicionar arquivo.', err)
    notifyError('Erro ao adicionar arquivo.')
    yield put({
      type: Types.ADD_FILE_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

function* deleteFile(action) {
  try {
    const fileId = action.payload

    const body = {
      arquivo_id: fileId,
      acao: 'excluir_arquivo',
    }

    console.tron.log('excluir_arquivo body', body)

    const res = yield powerAppsApi.post('/', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.tron.log('excluir_arquivo res.data', res.data)

    yield put({
      type: Types.DELETE_FILE_SUCCEEDED,
      payload: fileId,
    })

    notifySuccess('Arquivo removido com sucesso.')
  } catch (err) {
    console.tron.log('Erro ao remover arquivo.', err)
    notifyError('Erro ao remover arquivo.')
    yield put({
      type: Types.DELETE_FILE_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

export const filesSagas = [
  takeLatest(Types.ADD_FILE_REQUESTED, addFile),
  takeLatest(Types.DELETE_FILE_REQUESTED, deleteFile),
]
